import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";

const QR = () => {
  const { t } = useTranslation();
  const isMobile = window.innerWidth <= 768;

  return (
    <>
      <div className="parent-container-short">
        {/* <Link className="qr-collar-button" type="button" to="/order/qrcollar">
          <span>{t("price")}:</span> 230 {t("gel")}
        </Link> */}
        <div className="qr-tag-claim-steps-parent-container">
          <p className="containers-headline-text"> {t("how to activate")} </p>
          {/* <p className="title-description">
            {" "}
            {t("pethub tag features description")}{" "}
          </p>{" "} */}
          <div className="qr-tag-claim-steps-inside-container">
            {/* Step 1 */}
            <span className="qr-tag-claim-steps-card">
              <p className="qr-tag-claim-steps-title">
                {t("claim tag step 1 headline text")}
              </p>
              <img src="/img/step1.webp" alt="Step 1" loading="lazy" />
              <span className="qr-tag-claim-steps-description-container">
                <p className="qr-tag-claim-steps-title">
                  <span className="step-number">1</span>{" "}
                  {t("claim tag step 1 title")}
                </p>
                <p className="qr-tag-claim-steps-description">
                  {t("claim tag step 1 description")}
                </p>
              </span>
            </span>

            {!isMobile ? (
              <FontAwesomeIcon icon={faChevronRight} />
            ) : (
              <FontAwesomeIcon icon={faChevronDown} />
            )}

            {/* Step 2 */}
            <span className="qr-tag-claim-steps-card">
              <p className="qr-tag-claim-steps-title">
                {t("claim tag step 2 headline text")}
              </p>
              <img src="/img/step2.webp" alt="Step 2" loading="lazy" />
              <span className="qr-tag-claim-steps-description-container">
                <p className="qr-tag-claim-steps-title">
                  <span className="step-number">2</span>{" "}
                  {t("claim tag step 2 title")}
                </p>
                <p className="qr-tag-claim-steps-description">
                  {t("claim tag step 2 description")}
                </p>
              </span>
            </span>

            {!isMobile ? (
              <FontAwesomeIcon icon={faChevronRight} />
            ) : (
              <FontAwesomeIcon icon={faChevronDown} />
            )}

            {/* step 3 */}
            <span className="qr-tag-claim-steps-card">
              <p className="qr-tag-claim-steps-title">
                {t("claim tag step 3 headline text")}
              </p>
              <img src="/img/step3.webp" alt="Step 3" loading="lazy" />
              <span className="qr-tag-claim-steps-description-container">
                <p className="qr-tag-claim-steps-title">
                  <span className="step-number">3</span>{" "}
                  {t("claim tag step 3 title")}
                </p>
                <p className="qr-tag-claim-steps-description">
                  {t("claim tag step 3 description")}
                </p>
              </span>
            </span>

            {!isMobile ? (
              <FontAwesomeIcon icon={faChevronRight} />
            ) : (
              <FontAwesomeIcon icon={faChevronDown} />
            )}

            {/* step 4 */}
            <span className="qr-tag-claim-steps-card">
              <p className="qr-tag-claim-steps-title">
                {t("claim tag step 4 headline text")}
              </p>
              <img src="/img/step4.webp" alt="Step 3" loading="lazy" />
              <span className="qr-tag-claim-steps-description-container">
                <p className="qr-tag-claim-steps-title">
                  <span className="step-number">4</span>{" "}
                  {t("claim tag step 4 title")}
                </p>
                <p className="qr-tag-claim-steps-description">
                  {t("claim tag step 4 description")}
                </p>
              </span>
            </span>
          </div>{" "}
        </div>{" "}
        {/* <div className="how-it-works-inside-container-for-text important-message">
          <p className="how-it-works-page-important-requirment">
            {t("how it works page important requirment")}
          </p>
        </div> */}
        {/* <p className="qr-collar-title">{t("video instruction")}</p> */}
        {/* <iframe
          className="video-instruction"
          src="https://www.youtube.com/embed/MqPKWN0IhsA?si=DlkzcN_utmF_pQrv"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe> */}
        {/* <video autoplay>
          <source src="./img/petq.mp4" type={"video/mp4"} />
        </video> */}
      </div>
    </>
  );
};

export default QR;
